/// <reference path="../../components/modal/modal.module.ts" />

module Meevo.Plugins.Login {
    'use strict';

    angular
        .module('meevo.plugins.login', []);

}   